<!-- 未来网盘 -->
<template>
  <div class="fature-palte">
    <div class="header" style="height:40px;background:#ccc">
      <el-row>
        <el-col :span="3"></el-col>
        <el-col :span="3"></el-col>
        <el-col :span="5"></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="less" scoped>

</style>
